const {
  VUE_APP_INTL_PLATFORM_API_URL,
  VUE_APP_INTL_PLATFORM_AWS_REGION,
  VUE_APP_INTL_PLATFORM_AWS_AUTH,
  VUE_APP_INTL_PLATFORM_AWS_BUCKET,
  VUE_APP_INTL_PLATFORM_AWS_ID_POOL,
  VUE_APP_INTL_PLATFORM_AWS_USER_POOL_ID,
  VUE_APP_INTL_PLATFORM_AWS_USER_POOL_CLIENT_ID
} = process.env

export default () => (
  {
    url: VUE_APP_INTL_PLATFORM_API_URL,
    region: VUE_APP_INTL_PLATFORM_AWS_REGION,
    auth: VUE_APP_INTL_PLATFORM_AWS_AUTH,
    authenticationFlowType: 'CUSTOM_AUTH',

    Storage: {
      AWSS3: {
        bucket: VUE_APP_INTL_PLATFORM_AWS_BUCKET,
        region: VUE_APP_INTL_PLATFORM_AWS_REGION
      }
    },

    Auth: {
      identityPoolId: VUE_APP_INTL_PLATFORM_AWS_ID_POOL,
      region: VUE_APP_INTL_PLATFORM_AWS_REGION,
      userPoolId: VUE_APP_INTL_PLATFORM_AWS_USER_POOL_ID,
      userPoolWebClientId: VUE_APP_INTL_PLATFORM_AWS_USER_POOL_CLIENT_ID,
      mandatorySignIn: false
    }
  }
)
